// Import GSAP
import { gsap } from "gsap";

jQuery(document).ready(function ($) {
    var header = $(".header");
    var topSection = $(".header .top");
    var logo = $(".header .logo img");
    var headerOffset = header.offset().top;
    var originalHeaderHeight = header.outerHeight();
    var isSticky = false;
    var isAnimating = false;
    var scrollTicking = false;
    var tabletBreakpoint = 1024;

    var topExpanded = {
        opacity: 1,
        maxHeight: topSection[0] ? topSection[0].scrollHeight : 100,
        marginBottom: "0.625rem",
    };
    var logoExpandedWidth = "30rem";
    var logoCollapsedWidth = "15rem";
    var collapseDefaults = { duration: 0.35, ease: "power2.out" };
    var expandDefaults = { duration: 0.55, ease: "power3.inOut" };

    var placeholder = $('<div class="header-placeholder"></div>').css({
        height: originalHeaderHeight + "px",
        display: "none",
    });
    header.after(placeholder);

    function isDesktop() {
        return $(window).width() > tabletBreakpoint;
    }

    function syncPlaceholder() {
        placeholder.css("height", header.outerHeight() + "px");
    }

    function killHeaderTweens() {
        gsap.killTweensOf([header[0], topSection[0], logo[0]]);
    }

    function getFixedTop() {
        return $("body").hasClass("admin-bar") ? 32 : 0;
    }

    function updatePlaceholderHeight() {
        if (isDesktop()) {
            placeholder.css("height", originalHeaderHeight + "px");
        } else {
            placeholder.css("height", "0px");
        }
    }

    function measureDimensions() {
        if (topSection[0]) {
            topExpanded.maxHeight = topSection[0].scrollHeight;
        }
        if (!isSticky) {
            originalHeaderHeight = header.outerHeight();
        }
    }

    function resetToMobileState() {
        if (isSticky) {
            killHeaderTweens();
            isAnimating = false;
            gsap.set(header, { padding: "", clearProps: "padding" });
            gsap.set(topSection, {
                opacity: "",
                maxHeight: "",
                marginBottom: "",
                clearProps: "all",
            });
            gsap.set(logo, { width: "", clearProps: "width" });

            header.removeClass("scrolled");
            placeholder.hide();
            isSticky = false;
        }
    }

    function applyMobileScrolledState() {
        if (!isSticky) {
            placeholder.show();
            header.addClass("scrolled");

            gsap.set(header, { padding: "1rem 0" });
            gsap.set(topSection, { opacity: 0, maxHeight: 0, marginBottom: 0 });
            gsap.set(logo, { width: logoCollapsedWidth });

            isSticky = true;
        }
    }

    function animateToScrolled(onComplete) {
        killHeaderTweens();

        var startTop = header[0].getBoundingClientRect().top;
        var fixedTop = getFixedTop();

        placeholder.css({
            height: header.outerHeight() + "px",
            display: "block",
        });
        header.addClass("scrolled");
        gsap.set(header, { top: startTop });

        if (topSection[0]) {
            gsap.set(topSection, { maxHeight: topSection[0].scrollHeight });
        }

        gsap
            .timeline({
                defaults: collapseDefaults,
                onComplete: function () {
                    placeholder.css("height", header.outerHeight() + "px");
                    gsap.set(header, { clearProps: "top" });
                    onComplete && onComplete();
                },
            })
            .to(header, { top: fixedTop, padding: "1rem 0" }, 0)
            .to(topSection, { opacity: 0, maxHeight: 0, marginBottom: 0 }, 0)
            .to(logo, { width: logoCollapsedWidth }, 0);
    }

    function animateToExpanded(onComplete) {
        killHeaderTweens();

        gsap
            .timeline({
                onUpdate: syncPlaceholder,
                defaults: expandDefaults,
            })
            .to(header, { padding: "2rem 0" }, 0)
            .to(topSection, topExpanded, 0)
            .to(logo, { width: logoExpandedWidth }, 0)
            .call(function () {
                header.removeClass("scrolled");
                placeholder.hide();
                gsap.set([header, topSection, logo], { clearProps: "all" });
                onComplete && onComplete();
            });
    }

    function handleScroll() {
        var scrollTop = $(window).scrollTop();
        var shouldBeSticky = scrollTop > headerOffset + 50;

        if (isDesktop()) {
            if (isAnimating || shouldBeSticky === isSticky) {
                return;
            }

            isAnimating = true;

            if (shouldBeSticky) {
                animateToScrolled(function () {
                    isSticky = true;
                    isAnimating = false;
                });
            } else {
                animateToExpanded(function () {
                    isSticky = false;
                    isAnimating = false;
                });
            }
        } else {
            applyMobileScrolledState();
        }
    }

    $(window).on("scroll", function () {
        if (!scrollTicking) {
            scrollTicking = true;
            requestAnimationFrame(function () {
                handleScroll();
                scrollTicking = false;
            });
        }
    });

    $(window).on("resize", function () {
        measureDimensions();
        updatePlaceholderHeight();

        if (!isDesktop()) {
            applyMobileScrolledState();
        } else if (
            isSticky &&
            $(window).scrollTop() <= headerOffset + 50 &&
            !isAnimating
        ) {
            isAnimating = true;
            animateToExpanded(function () {
                isSticky = false;
                isAnimating = false;
            });
        }
    });

    updatePlaceholderHeight();
    if (!isDesktop()) {
        applyMobileScrolledState();
    }
});
